import React, { FC } from 'react';
import { NavigationProps } from '@interfaces/navigation';
import EventDetailsComponent from './components/EventDetailsComponent';
import MachinesProvider from '@v2/pages/machines/common/providers/MachinesProvider/MachinesProvider';
import { TimelineItemsList } from '@v2/pages/machines/modules/timeline/components/TimelineItemsList/TimelineItemsList';

interface EventDetailsProps extends NavigationProps {}

const EventDetails: FC<EventDetailsProps> = ({ lg }) => {
  return (
    <MachinesProvider
      lg={lg}
      panelViewMode={false} //TODO: remove this later
      onBack={() => {}}
      getList={(props) => <TimelineItemsList {...props} />}
    >
      <EventDetailsComponent />
    </MachinesProvider>
  );
};

export { EventDetails };
